/* SOLAS BRUTAL — interactions */
(function () {
  'use strict';

  /* mobile nav */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('.b-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('open'); });
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') nav.classList.remove('open'); });
  }

  /* scroll reveal */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* cart count */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  /* ajax add-to-cart — posts the FULL form so selling_plan (subscriptions),
     line item properties, etc. are included */
  document.querySelectorAll('form.js-atc').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) {
        setCartCount(cart.item_count);
        btn.textContent = 'ADDED ✓';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
      }).catch(function () {
        btn.textContent = 'SOLD OUT?';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
      });
    });
  });

  /* filter + sort grids */
  document.querySelectorAll('[data-grid-wrap]').forEach(function (wrap) {
    var grid = wrap.querySelector('[data-grid]');
    if (!grid) return;
    var cards = function () { return Array.prototype.slice.call(grid.querySelectorAll('.b-card')); };

    wrap.querySelectorAll('[data-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        wrap.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var f = chip.getAttribute('data-filter');
        cards().forEach(function (card) {
          var show = f === 'all' || card.getAttribute('data-origin') === f;
          card.classList.toggle('is-hidden', !show);
        });
      });
    });

    var sortSel = wrap.querySelector('[data-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var v = sortSel.value;
        var sorted = cards().sort(function (a, b) {
          var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
          var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
          var ta = (a.getAttribute('data-title') || '').toLowerCase();
          var tb = (b.getAttribute('data-title') || '').toLowerCase();
          if (v === 'price-asc') return pa - pb;
          if (v === 'price-desc') return pb - pa;
          if (v === 'az') return ta < tb ? -1 : 1;
          return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
        });
        sorted.forEach(function (c) { grid.appendChild(c); });
      });
    }
  });

  /* product page thumbnail swap */
  var mainImg = document.querySelector('[data-main-image]');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { mainImg.src = t.getAttribute('data-full'); });
    });
  }

  /* product page variant price update */
  var variantSel = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-product-price]');
  if (variantSel && priceEl) {
    variantSel.addEventListener('change', function () {
      var opt = variantSel.options[variantSel.selectedIndex];
      var p = opt.getAttribute('data-price-formatted');
      if (p) priceEl.textContent = p;
    });
  }
})();
